import React, { useState, useEffect } from 'react';
import { Card, Typography, Descriptions, Spin, Alert, Switch, message } from 'antd';
import { UserOutlined, PhoneOutlined, MailOutlined, BankOutlined, IdcardOutlined, BellOutlined, CloseOutlined } from '@ant-design/icons';
import userService from '../services/userService';
import { updateUserNotificationState, checkUserNotificationState } from '../services/notificationService';

const { Title } = Typography;

const UserProfile = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [enabled, setEnabled] = useState(true);
  const [toggling, setToggling] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    const fetchUserDetails = async () => {
      setLoading(true);
      try {
        const response = await userService.fetchCurrentUserDetails();
        if (response.success) {
          setUserDetails(response.data);
          setError(null);
        } else {
          setError(response.error || 'Failed to load user details');
        }
      } catch (err) {
        setError('An unexpected error occurred while loading user details');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchUserDetails();
  }, []);

  useEffect(() => {
    async function fetchState() {
      try {
        const response = await checkUserNotificationState();
        if (response) {
          var state = response.data.state;
          setEnabled(state ?? false);
        }
      }
      catch (error) { }
      console.error(error);
    }
    fetchState();
  }, []);

  const successMessage = (notify) => {

    const name = notify ? 'enabled' : 'disabled'

    messageApi.open({
      type: 'success',
      content: `Notifications succesfully ${name}`
    });
  };

  const errorMessage = () => {
    messageApi.open({
      type: 'error',
      content: 'Oops, Notifications settings not updated.',
    });
  };

  const handleToggle = async (checked) => {
    setEnabled(checked);
    setToggling(true);
    
    setTimeout(async () => {
      try {
        const response = await updateUserNotificationState();
        if (response) {
          const state = response.data.state;
          setEnabled(state ?? checked);
          successMessage(state)
        }
      } catch (error) {
        console.error(error);
        errorMessage();

        setEnabled(!checked);
      } finally {
        setToggling(false);
      }
    }, 1000);
  };


  if (loading) {
    return (
      <div className="loading-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
        <Spin size="large" tip="Loading user details..." />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '16px' }}>
        <Alert
          message="Error"
          description={error}
          type="error"
          showIcon
        />
      </div>
    );
  }

  return (
    <div className="user-profile-container" style={{ padding: '16px' }}>
      {contextHolder}
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: '100%' }}>
          <Card
            className="profile-card"
            bordered={true}
            style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
          >
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '15px' }}>
              <Switch style={{ outline: 'none', boxShadow: 'none', border: 'none' }}
                checked={enabled}
                checkedChildren={<BellOutlined />}
                unCheckedChildren={<BellOutlined />}
                onChange={handleToggle}
                loading={toggling}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '24px' }}>
              <div className="avatar" style={{
                background: '#000000',
                borderRadius: '50%',
                width: '80px',
                height: '80px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '8px'
              }}>
                <UserOutlined style={{ fontSize: '40px', color: '#fff' }} />
              </div>

              <Title level={3} style={{ margin: '8px 0' }}>
                {userDetails?.fullName}
              </Title>
              <Typography.Text type="secondary">
                {userDetails?.roleType}
              </Typography.Text>
            </div>

            <Descriptions
              bordered
            >
              <Descriptions.Item label={<span><PhoneOutlined /> Contact Number</span>}>
                {userDetails?.mobileNumber || 'Not provided'}
              </Descriptions.Item>

              <Descriptions.Item label={<span><MailOutlined /> Email</span>}>
                {userDetails?.email || 'Not provided'}
              </Descriptions.Item>

              <Descriptions.Item label={<span><BankOutlined /> Company</span>}>
                {userDetails?.companyName || 'Not provided'}
              </Descriptions.Item>

              <Descriptions.Item label={<span><IdcardOutlined /> Role</span>}>
                {userDetails?.roleType}
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
